Date.prototype.toStringRu = function () {
    return '' + (this.getDate() > 9 ? '' : '0') + this.getDate() + '.' + (this.getMonth() > 8 ? '' : '0') + (this.getMonth() + 1) + '.' + this.getFullYear();
};